import itemsNotSoldDialogTemplate from "./ItemsNotSoldDialog.html";

/*****************************************************************************
 * Service: ItemsNotSoldDialog */
/**
 * @ngdoc     service
 * @module    csm.books.fundraisers
 * @name      csm.books.fundraisers.service:ItemsNotSoldDialog
 * @description
 * This service will display a dialog to optionally select a unsold item.
 *****************************************************************************/
/* @ngInject */ export function ItemsNotSoldDialogService($q, $uibModal) {
  /*****************************************************************************
   * show */
  /**
   * @ngdoc    function
   * @name     show
   * @methodOf csm.books.fundraisers.service:ItemsNotSoldDialog
   * @param    {Array}  itemsNotSold    Items Not Sold List.
   * @return   {Promise}                Resolves upon close of the modal dialog.
   *                                    When item is selected, it is sent back as
   *                                    resolve data.
   *****************************************************************************/
  this.show = function (itemsNotSold) {
    return $uibModal.open({
      backdrop: 'static',
      component: 'itemsNotSold',
      size: 'sm',
      resolve: {
        dpItems: function () {
          return itemsNotSold;
        }
      }
    }).result;
  };
}

/*****************************************************************************
 * Component: itemsNotSold */
/**
 * @ngdoc     component
 * @module    csm.books.fundraisers
 * @name      csm.books.fundraisers.component:itemsNotSold
 * @param  {Object} modalInstance $uibModal instance from $uibModal.open method
 * @param  {Object} resolve       Resolve object passed from $uibModal.open method
 * @description
 * This component will handle the selection of an item. This component is
 * expected to be used with the AddChangeFundraiserItemDialog.
 *****************************************************************************/
export const ItemsNotSoldDialogComponent = {
  template: itemsNotSoldDialogTemplate,
  bindings: { modalInstance: '<', resolve: '<' },
  controller: ItemsNotSoldController
};

/*****************************************************************************
 * Controller: ItemsNotSoldController */
/**
 * @ngdoc     controller
 * @module    csm.books.fundraisers
 * @methodof  csm.books.fundraisers.itemsNotSold.controller:ItemsNotSoldController
 * @description
 * Main controller for {@link itemsNotSold} component.
 *****************************************************************************/
/* @ngInject */ function ItemsNotSoldController($injector) {
  var $ctrl = this;
  $ctrl.$onInit = $injector.invoke($onInit, null, { $ctrl: $ctrl });
  $ctrl.close = $injector.invoke(close, null, { $ctrl: $ctrl });
}

/*****************************************************************************
 * $onInit */
/**
 * @ngdoc    function
 * @name     $onInit
 * @methodOf csm.books.fundraisers.itemsNotSold.controller:ItemsNotSoldController
 * @description
 * Called by angular when the component is ready. Loads items dropdown dataprovider.
 *****************************************************************************/
/* @ngInject */ function $onInit($ctrl) {
  return function () {
    $ctrl.dpItems = $ctrl.resolve.dpItems;
  };
}

/*****************************************************************************
 * close */
/**
 * @ngdoc    function
 * @name     close
 * @methodOf csm.books.fundraisers.itemsNotSold.controller:ItemsNotSoldController
 * @param  {Boolean}  True=return the selected item when dialog is closed.
 * @description
 * Called when either the `Select` or `Close` button is clicked. This will close
 * the dialog. If useSelection is true, the selected item is returned. Else it is
 * ignored.
 *****************************************************************************/
/* @ngInject */ function close($ctrl) {
  return function (returnSelection) {
    /*------------------------------------------------*/
    /* Selection required but nothing selected, exit. */
    /*------------------------------------------------*/
    if (returnSelection && !$ctrl.selectedItem) return;

    /*-------------------------------------*/
    /* Close the dialog with the selection */
    /* if required, else send nothing.     */
    /*-------------------------------------*/
    $ctrl.modalInstance.close(
      returnSelection ? $ctrl.selectedItem.itemName : null
    );
  };
}
